import i18n from "i18n-js";

import { languagesLocaleEnabled } from "../utils/languagesLocaleEnabled";

i18n.fallbacks = true;
i18n.translations = {};

languagesLocaleEnabled().forEach((language) => {
  i18n.translations[language] = require(`./${language}.json`);
});

const userLang = navigator.language;
const browserLang = userLang.replace("-", "").toLocaleLowerCase();
const regionLang = userLang.split("-")[0];

const savedLang = localStorage.getItem("@Lang");
if (savedLang && i18n.translations[savedLang]) {
  i18n.locale = localStorage.getItem("@Lang");
} else if (i18n.translations[browserLang]) {
  i18n.locale = browserLang;
} else if (i18n.translations[regionLang]) {
  i18n.locale = regionLang;
} else {
  i18n.locale = Object.keys(i18n.translations)[0];
}

const translate = (val, vars = {}) => i18n.t(val, vars);

export { i18n };

export default translate;
